import { useState, useEffect } from "react"
import { ArrowRight, ChevronDown, ChevronUp } from "lucide-react"
import Footer from "../components/Footer"
import InnerHeader from "@/components/InnerHeader"
import { productApi } from "@/http/apiList"
import { useNavigate } from 'react-router-dom';

// --- Data ---
// const pageData = [
//   {
//     region: "Mainland China",
//     products: Array(8).fill({
//       title: "Alphas based on Call Auction trading PV data",
//       description:
//         "Call Auction refers to a trading mechanism where all buy and sell orders received within a specified time window are matched in a single batch at a unified price. All transactions in the call auction.",
//     }),
//   },
//   {
//     region: "HongKong SAR",
//     products: Array(9).fill({
//       title: "Alphas based on Call Auction",
//       description:
//         "Call Auction refers to a trading mechanism where all buy and sell orders received within a specified time window are matched in a single batch at a unified price. All transactions in the call auction.",
//     }),
//   },
//   {
//     region: "United States",
//     products: Array(5).fill({
//       title: "Alphas based on Call Auction",
//       description:
//         "Call Auction refers to a trading mechanism where all buy and sell orders received within a specified time window are matched in a single batch at a unified price. All transactions in the call auction.",
//     }),
//   },
// ]

// --- Components ---

const ProductCard = ({ product }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(`/data-detail/${product.key}`);
  }
  return( <div className="bg-gray-100/80 p-[26px] rounded-lg flex flex-col h-[314px]">
    <h3 className="font-bold text-[22px] mb-3 text-[#161616]">{product.title}</h3>
    <p className="text-gray-600 text-sm leading-relaxed mb-[30px] flex-grow h-[130px] overflow-hidden line-clamp-7">{product.content}</p>
    <div className="text-blue-600 font-semibold text-[20px] flex items-center group cursor-pointer" onClick={handleClick}>
      learn more
      <ArrowRight className="w-[24px] h-[24px] ml-[24px] transition-transform group-hover:translate-x-2" />
    </div>
  </div>
)}

const RegionSection = ({ region, products }) => {
  const [isExpanded, setIsExpanded] = useState(true)
  const hasMore = products.length > 6

  const visibleProducts = isExpanded ? products : products.slice(0, 6)

  return (
    <section className="mb-16">
      <div className="flex justify-between items-center mb-8">
        <h2 className="text-[40px] text-[#161616]">{region}</h2>
        {hasMore && (
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="flex items-center text-blue-600 font-semibold text-[20px]"
          >
            {isExpanded ? "Hide" : "View more"}
            {isExpanded ? <ChevronUp className="w-[24px] h-[24px] ml-1" /> : <ChevronDown className="w-[24px] h-[24px] ml-1" />}
          </button>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {visibleProducts.map((product, index) => (
          <ProductCard key={index} product={product} />
        ))}
      </div>
    </section>
  )
}

export default function DataProductsPage() {
  const [ pageData, setPageData ] = useState([]);
  const getProductData = async () => {
    const data = await productApi.getProductList({ key: '1' })
    setPageData(data.data);
  }
  useEffect(() => {
    getProductData();
  }, []);
  return (
    <div className="bg-white">
      {/* Header */}
      <InnerHeader></InnerHeader>
      {/* Main Content */}
      <main className="container max-w-7xl mx-auto px-4 py-16">
        {pageData.map((section, index) => (
          <RegionSection key={`${section.category}${index}`} region={section.category} products={section.item} />
        ))}
      </main>
      <Footer></Footer>
    </div>
  )
}
